module.exports = __webpack_public_path__ + "static/img/hhh.fb11115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/hhh.jpg
// module id = zlrW
// module chunks = 1